import React from 'react'

import './CompanyChange.css'
import Backdrop from 'components/UI/Backdrop/Backdrop'
import Aux from 'hoc/ReactAux/ReactAux'

const CompanyChange = (props) =>{

  if (!props.show) {
    return null
  }

  let disabled = null
  if (props.invalid){
    disabled = {
        background: 'white',
        color: '#ff5007',
        border: '1px solid #ff5007',
        cursor: 'not-allowed'
      }
  }

  return(
    <Aux>
      <Backdrop show={true} />
      <div id="settings" className="mfp-bg-login white-popup-block lb-centralizar singup zoom-anim-dialog moda-company-change">
        <div className="lb-settings lb-padrao-singup6 mfp-content-login modal-content">
          <button onClick={() => props.close()} title="Close (Esc)" type="button" className="mfp-close lb-fechar fa fa-times"></button>
          <article>
            <header>
                <h3>Company Change Request</h3>
            </header>
            <div>
              <div className="config-item">
                <label>
                    Email
                </label>
                <input type="text" name="email" value="support@lunch.team" disabled />
              </div>
              <div className="config-item">
                <label>
                    Message
                </label>
                <textarea onChange={(evt) => props.handleChangeMessage(evt)} name="message"></textarea>
              </div>
              <button
                disabled={props.invalid}
                style={disabled}
                onClick={props.sendMessage}
                className="orange-bold"> Send </button>
            </div>
          </article>
        </div>
      </div>
    </Aux>
  )
}

export default CompanyChange



// WEBPACK FOOTER //
// ./src/containers/Settings/CompanyChange/index.js